import React from 'react'
import PropTypes from 'prop-types'

const Button = ({
  className, type, disabled, onClick, children, ...rest
}) => (
  <button className={ className } type='button' disabled={ disabled } onClick={ onClick } { ...rest }>
    {children}
  </button>
)

Button.defaultProps = {
  type: '',
  className: 'btn generic-button',
  onClick: () => null,
  children: null,
  disabled: false,
}

Button.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.string,
    PropTypes.array,
  ]),
  disabled: PropTypes.bool,
}

export default Button
